import * as React from 'react';
import S from './DotPagination.styles';
const DotPagination = ({ autoplay = 0, count, paused = false, value, customLayoutId = 'indicator', onChange, }) => {
    return (React.createElement(S.Container, { "aria-label": "Slider Pagination" }, Array.from(Array(count)).map((_, index) => (React.createElement(S.Item, { key: `DotPaginationItem_${index}`, "aria-current": index === value, "aria-label": `Go to ${index + 1}`, onClick: (event) => {
            event.preventDefault();
            onChange(index);
        } }, index === value && renderActiveIndicator())))));
    function renderActiveIndicator() {
        const isActiveAnimating = autoplay > 0 && !paused;
        if (isActiveAnimating) {
            return (React.createElement(S.SvgIndicator, { "aria-hidden": true, viewBox: "0 0 33 33" },
                React.createElement(S.Circle, { cx: "16.5", cy: "16.5", r: "14.5", initial: { pathLength: isActiveAnimating ? 0 : 1 }, animate: { pathLength: 1 }, transition: { duration: autoplay / 1000, ease: 'linear' }, style: { rotate: -90 } })));
        }
        return (React.createElement(S.ActiveIndicator, { "aria-hidden": true, 
            // "layoutId" handles animating between positions automatically.
            layoutId: customLayoutId, transition: {
                duration: 0.3,
                ease: 'easeOut',
            } }));
    }
};
export default DotPagination;
